import styled from 'styled-components';

/* eslint-disable import/prefer-default-export */
export const Container = styled.div<{ $padded?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  ${({ $padded }) => $padded && 'padding: 0 16px; box-sizing: border-box;'}
`;

export const PoweredByBanner = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 24px;
  background: #f3f3f2 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #101828 !important;
  font-size: 12px;
  z-index: 100;
`;

export const DashboardContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;
